export const spacingVariables = {
  'spacing-none': '0px',
  'spacing-xxxs': '4px',
  'spacing-xxs': '8px',
  'spacing-xs': '12px',
  'spacing-sm': '16px',
  'spacing-md': '24px',
  'spacing-lg': '32px',
  'spacing-xl': '40px',
  'spacing-xxl': '48px',
  'spacing-xxxl': '64px',
};
